import React from 'react';
import withRoot from './modules/withRoot';
import ListeningGame from './modules/views/ListeningGame';
import { UI_BASE_URL } from './consts';
import AppFooter from './modules/views/AppFooter';
import AppAppBar from './modules/views/AppAppBar';
import GameCardTest from './modules/components/GameCardTest';


const Page = () => (
    <React.Fragment>
        <AppAppBar />
        <GameCardTest
            path={UI_BASE_URL} // TODO: change
        />
        <AppFooter />
    </React.Fragment>
);

export default withRoot(Page);
